// eslint-disable-next-line valid-jsdoc
/**
 * 人物标签管理
 */
angular.module('mediaTagManagerModule').controller('peopleMarkCtrl', [
    '$scope',
    '$controller',
    'messagePublishService',
    function($scope, $controller, messagePublishService) {
        initScope();
        initStatus();
        initData();

        /**
         * [initScope 初始化作用域，继承素材库主控制器]
         *
         * @return  {[type]}          [return description]
         */
        function initScope() {
            let vm = this || window;
            let parentCtr = $controller('mediaTagCtrl', { $scope: $scope });
            vm = angular.extend(vm, parentCtr);
        }

        /**
         * [initStatus 初始化人物标签状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.name = '人物标签';
            $scope.queryParams.type = 'person';
        }

        /**
         * [initData 初始化人物标签数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.requestData();
        }
    },
]);
